'use client';

import { PropsWithChildren } from 'react';

import { cn } from '~/lib/utils/classname';

interface Props extends PropsWithChildren {
  className?: string;
}

const MainContent: React.FC<Props> = ({ className, children }) => {
  return <main className={cn('min-h-svh', className)}>{children}</main>;
};

export default MainContent;
